var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import { Popover, TextField, InputAdornment, IconButton } from '@mui/material';
import { CalendarMonth } from '@mui/icons-material';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { DateCalendar } from '@mui/x-date-pickers/DateCalendar';
import { PickersDay } from '@mui/x-date-pickers/PickersDay';
import dayjs from 'dayjs';
var FORMATO = 'YYYY-MM-DD';
// Seletor de intervalo de datas em um único campo (estilo "passagem aérea"):
// abre um calendário, clica na data inicial e depois na final.
export var RangeDatePicker = function (_a) {
    var _b;
    var inicio = _a.inicio, fim = _a.fim, onChange = _a.onChange, label = _a.label, _c = _a.placeholder, placeholder = _c === void 0 ? 'Selecione o período' : _c, disabled = _a.disabled, _d = _a.fullWidth, fullWidth = _d === void 0 ? true : _d;
    var _e = useState(null), anchorEl = _e[0], setAnchorEl = _e[1];
    var open = Boolean(anchorEl);
    var inicioD = inicio ? dayjs(inicio) : null;
    var fimD = fim ? dayjs(fim) : null;
    var formatar = function (valor) { return (valor ? dayjs(valor).format('DD/MM/YYYY') : ''); };
    var display = inicioD || fimD ? "".concat(formatar(inicio) || '...', " \u2192 ").concat(formatar(fim) || '...') : '';
    var abrir = function (event) {
        if (!disabled)
            setAnchorEl(event.currentTarget);
    };
    var aoSelecionarDia = function (valor) {
        if (!valor)
            return;
        // Sem início ou intervalo completo -> inicia novo intervalo.
        if (!inicioD || (inicioD && fimD)) {
            onChange(valor.format(FORMATO), null);
            return;
        }
        // Já há início -> define o fim (se anterior ao início, reinicia).
        if (valor.isBefore(inicioD, 'day')) {
            onChange(valor.format(FORMATO), null);
        }
        else {
            onChange(inicio, valor.format(FORMATO));
            setAnchorEl(null);
        }
    };
    var renderDia = function (props) {
        var day = props.day, rest = __rest(props, ["day"]);
        var ehInicio = !!inicioD && day.isSame(inicioD, 'day');
        var ehFim = !!fimD && day.isSame(fimD, 'day');
        var noIntervalo = !!inicioD && !!fimD && day.isAfter(inicioD, 'day') && day.isBefore(fimD, 'day');
        return (_jsx(PickersDay, __assign({}, rest, { day: day, selected: ehInicio || ehFim, sx: noIntervalo
                ? { backgroundColor: 'primary.light', color: 'primary.contrastText', borderRadius: 0 }
                : undefined })));
    };
    return (_jsxs(_Fragment, { children: [_jsx(TextField, { label: label, value: display, placeholder: placeholder, size: 'small', fullWidth: fullWidth, disabled: disabled, onClick: abrir, InputLabelProps: { shrink: true }, InputProps: {
                    readOnly: true,
                    endAdornment: (_jsx(InputAdornment, __assign({ position: 'end' }, { children: _jsx(IconButton, __assign({ edge: 'end', disabled: disabled, onClick: abrir, "aria-label": 'abrir calend\u00E1rio' }, { children: _jsx(CalendarMonth, {}) })) }))),
                } }), _jsx(Popover, __assign({ open: open, anchorEl: anchorEl, onClose: function () { return setAnchorEl(null); }, anchorOrigin: { vertical: 'bottom', horizontal: 'left' } }, { children: _jsx(LocalizationProvider, __assign({ dateAdapter: AdapterDayjs }, { children: _jsx(DateCalendar, { value: (_b = fimD !== null && fimD !== void 0 ? fimD : inicioD) !== null && _b !== void 0 ? _b : null, onChange: function (valor) { return aoSelecionarDia(valor); }, slots: { day: renderDia } }) })) }))] }));
};
export default RangeDatePicker;
